var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 18",
    clipPath: "url(#clip0_346_26482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1427 11.2379C13.1427 7.02958 16.5534 3.61886 20.7617 3.61886C24.9701 3.61886 28.3808 7.02958 28.3808 11.2379C28.3808 15.4462 24.9701 18.857 20.7617 18.857C20.1427 18.857 19.5415 18.7855 18.9701 18.6427C18.4879 18.5236 17.976 18.6665 17.6248 19.0236L15.8867 20.7617H12.6665C11.8748 20.7617 11.2379 21.3986 11.2379 22.1903V24.5712H8.85696C8.06529 24.5712 7.42839 25.2081 7.42839 25.9998V28.3808H3.61886V23.732L12.976 14.3748C13.3272 14.0236 13.4701 13.5117 13.357 13.0296C13.2201 12.4581 13.1427 11.857 13.1427 11.2379ZM20.7617 0.761719C14.976 0.761719 10.2855 5.4522 10.2855 11.2379C10.2855 11.8034 10.3272 12.357 10.4165 12.8986L1.17839 22.1308C0.910528 22.3986 0.761719 22.7617 0.761719 23.1427V29.8093C0.761719 30.601 1.39862 31.2379 2.19029 31.2379H8.85696C9.64862 31.2379 10.2855 30.601 10.2855 29.8093V27.4284H12.6665C13.4581 27.4284 14.0951 26.7915 14.0951 25.9998V23.6189H16.476C16.857 23.6189 17.2201 23.4701 17.4879 23.2022L19.107 21.5831C19.6486 21.6665 20.2022 21.7141 20.7677 21.7141C26.5534 21.7141 31.2439 17.0236 31.2439 11.2379C31.2439 5.4522 26.5474 0.761719 20.7617 0.761719ZM22.6665 11.2379C23.1717 11.2379 23.6561 11.0372 24.0133 10.68C24.3706 10.3228 24.5712 9.83832 24.5712 9.33315C24.5712 8.82797 24.3706 8.34349 24.0133 7.98628C23.6561 7.62907 23.1717 7.42839 22.6665 7.42839C22.1613 7.42839 21.6768 7.62907 21.3196 7.98628C20.9624 8.34349 20.7617 8.82797 20.7617 9.33315C20.7617 9.83832 20.9624 10.3228 21.3196 10.68C21.6768 11.0372 22.1613 11.2379 22.6665 11.2379Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_346_26482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.32ab72fec8aaf6e840ae5b7e4f86d99c.svg";
export { ForwardRef as ReactComponent };